import type { GiftPassStatus, GiftPassSummary } from '../../api/gift-passes';

import { GIFT_PASS_STATUS_LABEL } from './gift-passes-model';

const STATUSES: GiftPassStatus[] = ['ISSUED', 'SENT', 'REDEEMED', 'VOIDED', 'EXPIRED'];

/** Counts cover the whole filter, not just the page. Hidden on phones, where it crowds the cards. */
export function GiftPassesSummaryRow({ summary }: { summary: GiftPassSummary }) {
  const cells = [
    { label: 'Total passes', value: summary.totalPasses },
    ...STATUSES.map((s) => ({ label: GIFT_PASS_STATUS_LABEL[s], value: summary.byStatus[s] })),
  ];
  return (
    <div className="nb-kpi-strip gp-summary" role="group" aria-label="Gift pass counts">
      {cells.map((cell) => (
        <div key={cell.label} className="nb-kpi-cell">
          <div className="nb-eyebrow" style={{ fontSize: 10 }}>
            {cell.label}
          </div>
          <div
            className="nb-tabular"
            style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-0.02em', marginTop: 4 }}
          >
            {cell.value.toLocaleString('en-US')}
          </div>
        </div>
      ))}
    </div>
  );
}
